import { Location, NavigateFunction } from 'react-router-dom'
import queryString from 'query-string'
import { RteModalQueryParams } from 'src/components/RichTextEditor'
import { PolicyRecord } from '@trustero/trustero-api-web/lib/model/policy_pb'

export const editDocumentMarkdown = (
  documentId: string,
  material: string,
  setMarkdownBody: React.Dispatch<React.SetStateAction<string>>,
  navigate: NavigateFunction,
  location: Location,
): void => {
  setMarkdownBody(material)
  navigate(
    queryString.stringifyUrl(
      {
        url: location.pathname,
        query: {
          ...queryString.parse(location.search, {
            arrayFormat: 'bracket',
          }),
          [RteModalQueryParams.SHOW_RTE_MODAL]: true,
          [RteModalQueryParams.UNIQUE_ID]: documentId,
          [RteModalQueryParams.SHOW_WIZARD]: false,
        },
      },
      {
        arrayFormat: 'bracket',
      },
    ),
  )
}

export type PolicyFieldSnapshot = {
  description: string
  lastReviewedDate: number
  lastApprovedDate: number
}

export const getPolicyFieldSnapshot = (
  policy: PolicyRecord | undefined,
): PolicyFieldSnapshot => ({
  description: policy?.getDescription() ?? '',
  lastReviewedDate: policy?.getLastReviewedDate()?.getSeconds() ?? 0,
  lastApprovedDate: policy?.getLastApprovedDate()?.getSeconds() ?? 0,
})

export const policyFieldsChanged = (
  initial: PolicyFieldSnapshot,
  current: PolicyFieldSnapshot,
): boolean =>
  current.description !== initial.description ||
  current.lastReviewedDate !== initial.lastReviewedDate ||
  current.lastApprovedDate !== initial.lastApprovedDate
